import { IconName } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const toasterTypes = [
  'success',
  'error',
  'warning',
  'info',
  'neutral',
] as const;
export type ToasterType = (typeof toasterTypes)[number];

export type ToasterStyle = {
  icon: {
    color: CSSResult;
    name: IconName;
  };
  background: CSSResult;
  border: CSSResult;
};
